<template>
  <div
    id="page-wrapper"
    class="startpage-page wrap-container"
  >
    <section>
      <startPageBirthday
        v-if="birthdayBanner"
        :item="birthdayBanner"
        :customer="customerContentResult.customer"
      />
      <hero-block
        v-else
        edit-prefix="HeroBlock"
        :branding-image="brandingImage"
        :theme="theme"
        :prefix="prefix"
        :title="title"
        :content="content"
        :primary-button-label="primaryButtonLabel"
        :secondary-button-label="secondaryButtonLabel"
        :primary-url="primaryUrl"
        :secondary-url="secondaryUrl"
        :background-image="backgroundImage"
        :image-sizes="heroDimensions"
        :use-picture="false"
        :one-url-epi-picture="true"
      />
    </section>
    <section v-if="quickLinks.length">
      <startPageQuickLinks
        :items="quickLinks"
        :class="(birthdayBanner ? 'startpage-quicklink--noHero' :'')"
      />
    </section>
    <section v-if="inspirationalContentArea.length || isEditable">
      <sub-heading
        heading="Inspiration"
      />
      <block-grid
        v-edit="'inspirationalContentArea'"
        :blocks="inspirationalContentArea"
        :custom-size="fixedSizeFull"
        :tracking="{
          listName: 'Inspiration',
          listLength: String(inspirationalContentArea.length)
        }"
        @open-folder-modal="openFolderModal"
      />
    </section>
    <section>
      <div class="searchpromo-component">
        <span class="searchpromo-component__prefix">{{ (additionalInfo && additionalInfo.totalRecipesInfo) || "Sök bland alla våra recept" }}</span>
        <h2 class="searchpromo-component__heading">
          Vad vill du äta idag?
        </h2>
        <form
          class="searchpromo-component__form"
          @submit.prevent="doSearch"
        >
          <input
            id="searchpromo-component__input"
            ref="searchpromo-component__input"
            name="search"
            class="searchpromo-component__input"
            type="search"
            autocapitalize="off"
            autocomplete="off"
            :placeholder="($root.isSmallViewport ? 'Sök på recept' : 'Sök på ingredienser eller recept')"
          >
          <input
            id="searchpromo-component__submit"
            class="searchpromo-component__submit button "
            :class="($root.isSmallViewport ? 'button--32' : 'button--40')"
            type="submit"
            value="Sök"
          >
        </form>
        <div
          v-if="similiarLinksRenamed.length || isEditable"
          class="searchpromo-component__related"
        >
          <IcaRelatedItems
            :items="similiarLinksRenamed"
            :align="'center'"
            :size="($root.isSmallViewport ? 32 : 40)"
            :type="'secondary'"
            :limit="!isEditable ? 9 : 0"
            @related-item-click="trackRelatedItemsClick"
            @related-item-show-more="trackRelatedItemsShowmore"
          />
        </div>
      </div>
    </section>
    <section
      v-if="recipeGroupContentArea.length"
      class="startpage-recipegroup"
    >
      <sub-heading
        v-if="recipeGroupContentArea.length || isEditable"
        :heading="recipeGroupPagesTitle"
      />
      <ReceptVirtualGroupBlock
        :tracking-list-name="recipeGroupPagesTitle"
        :recipe-group-content-area="recipeGroupContentArea"
        @open-folder-modal="openFolderModal"
      />
    </section>
    <section
      v-if="mdsaNavigatablePages.length"
    >
      <navigation-blocks
        v-if="mdsaNavigatablePages.length"
        :navigation-blocks="mdsaNavigatablePages"
        :display-image-state="false"
        :show-more-limit="!isEditable ? ($root.isSmallViewport ? 4 : 10) : 0"
      >
        <sub-heading
          v-if="mdsaNavigatablePages.length || isEditable"
          :v-edit-heading="'MdsaNavigatablePagesTitle'"
          :heading="mdsaNavigatablePagesTitle"
        />
      </navigation-blocks>
    </section>
    <ica-add-single-recipe-to-folder-modal
      v-if="$root.isLoggedIn"
      :active="showFolderModal"
      :recipe-id="activeRecipeId"
      :recipe-name="activeRecipeTitle"
      :get-access-token-fn="getPublicAccessToken"
      :recipe-base-url="$root.envConfig.recipeExperienceApiBaseUrl"
      @save-to-folder="saveToFolder"
      @close-modal="closeModal"
    />
  </div>
</template>
<script>
import pageWithNavigation from '@/vue/mixins/pageWithNavigation'
import StartPageQuickLinks from '@/vue/components/StartPageQuickLinks.vue'
import StartPageBirthday from '@/vue/components/StartPageBirthday.vue'
import ReceptVirtualGroupBlock from '@/vue/blocks/ReceptVirtualGroupBlock/receptVirtualGroupBlock.vue'
import IcaRelatedItems from "~/@ica/ica-molecules-vue/dist/RelatedItems"
import HeroBlock from '@/vue/blocks/HeroBlock/heroBlock'
import analytics from '@/analytics/dataLayerStartpage'
import recipeModalMixin from '@/vue/mixins/recipeModalMixin'

export default {
  name: 'StartPage',
  components: {
    StartPageBirthday,
    StartPageQuickLinks,
    ReceptVirtualGroupBlock,
    IcaRelatedItems,
    HeroBlock,
  },
  mixins: [pageWithNavigation, recipeModalMixin],
  props: {
    customerContentResult: {
      type: Object,
      default: null
    },
    quickLinks: {
      type: Array,
      default: () => []
    },
    brandingImage: {
      type: Object,
      default: null
    },
    theme: {
      type: String,
      default: "Default"
    },
    prefix: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    content: {
      type: String,
      default: ""
    },
    primaryButtonLabel: {
      type: String,
      default: ""
    },
    secondaryButtonLabel: {
      type: String,
      default: ""
    },
    primaryUrl: {
      type: String,
      default: ""
    },
    secondaryUrl: {
      type: String,
      default: ""
    },
    backgroundImage: {
      type: Object,
      default: null
    },
    inspirationalContentArea: {
      type: Array,
      default: () => []
    },
    similiarLinks: {
      type: Array,
      default: () => []
    },
   recipeGroupPagesTitle: {
      type: String,
      default: 'Låt oss inspirera dig'
    },
    recipeGroupContentArea: {
      type: Array,
      default: () => []
    },
    mdsaNavigatablePagesTitle: {
      type: String,
      default: 'Många söker just nu på'
    },
    mdsaNavigatablePages: {
      type: Array,
      default: () => []
    },
    additionalInfo: {
      type: Object,
      default: () => ({})
    },
  },
  data () {
    return {
      similiarLinksRenamed: [],
      fixedSizeFull: {
        isSmallViewport: {
          size: "full",
        }
      },
      heroDimensions: {
        small: {
          height: 422,
          width: 767
        },
        medium: {
          height: 651,
          width: 1023
        },
        large: {
          height: 520,
          width: 1232
        }
      },
    }
  },
  computed: {
    birthdayBanner () {
      if (this.customerContentResult && this.customerContentResult.content && this.customerContentResult.content.banners) {
        return this.customerContentResult.content.banners.find(item => item.type == 'birthday-banner')
      }
      return false
    }
  },
  mounted () {
    this.similiarLinksRenamed = this.similiarLinks.map(a=>{
      return {
        text: a.name,
        url: a.url
      }
    })
  },
  methods: {
    trackRelatedItemsClick (data) {
      data.itemsListLength = this.similiarLinksRenamed.length
      analytics.onTrackRelatedItemsClick(data)
    },
    trackRelatedItemsShowmore () {
      analytics.onTrackRelatedItemsShowmore()
    },
    doSearch () {
      const searchTerm = encodeURIComponent(this.$refs['searchpromo-component__input'].value)
      location.href = `/recept/#:search=${searchTerm}`
    }
  }
}
</script>
<style lang="scss" >
.startpage-page {
  padding-bottom: 0;

  @include media-breakpoint-up (md) {
    margin-top: 3.5rem;
  }

  @include media-breakpoint-up (xl) {
    margin-top: 4.5rem;
    padding-bottom: 1.5rem;

    .hero-block__image {
      border-radius: 0.25rem 0.25rem 0 0;
    }
  }

  .hero-block .epi-background-container,
  .hero-block .empty-image-placeholder {
    padding-bottom: 56.25%;

    @include media-breakpoint-up (lg) {
      padding-bottom: 42.20779220779221%;
    }
  }

  .hero-block {
    margin-bottom: 0;
  }

  .hero-block__content-wrapper {
    @include media-breakpoint-up (xl) {
      top: -40px;
    }
  }

  .navigation-block {
    margin-top: 3rem;
  }
}

.searchpromo-component {
  @include default-margin();

  margin-right: -1rem;
  margin-left: -1rem;
  border-radius: 0;
  background-color: $color-white;
  text-align: center;
  padding: 2rem 1.5rem;

  @include media-breakpoint-up(md) {
    border-radius: 2.5rem;
    padding: 4rem 1rem 3.5rem;
    margin-right: 0;
    margin-left: 0;
    box-shadow: $box-shadow-primary;
  }

  &__prefix {
    @include font(hand, 3, "normal");

    line-height: 1.5rem;
    color: $color-red;
    margin-bottom: 0.5rem;
    display: block;

    @include media-breakpoint-up(md) {
      @include font(hand, 1, "normal");

      margin-bottom: 1rem;
    }
  }

  &__heading {
    margin: 0 0 1rem 0;

    @include font(rubrik, 7, "black");

    @include media-breakpoint-up(md) {
      margin-bottom: 2rem;
    }

    @include media-breakpoint-up(lg) {
      margin-bottom: 2rem;
    }
  }

  &__form {
    position: relative;
    margin-bottom: 1rem;

    @include media-breakpoint-up(md) {
      max-width: 37.5rem;
      margin: 0 auto 3rem auto;
    }

    @include media-breakpoint-up(lg) {
      max-width: 42.5rem;
    }
  }

  &__submit {
    position: absolute;
    right: 0.5rem;
    top: 0.5rem;
  }

  &__related {
    max-width: 36.5rem;
    display: inline-block;

    @include media-breakpoint-up(lg) {
      max-width: 50rem;
    }
  }

  &__input {
    @include font(text, 3, "normal");

    padding: 0.75rem 0.75rem;
    width: 100%;
    border: 0.0625rem solid $color-grey-light;
    border-radius: 0.25rem;
    appearance: none;
    height: 3rem;
    color: $color-grey-dark;

    @include media-breakpoint-up(md) {
      height: 3.5rem;
    }

    &::-ms-clear,
    &::-ms-reveal {
      display: none;
      width: 0;
      height: 0;
    }

    &::-webkit-search-decoration,
    &::-webkit-search-cancel-button,
    &::-webkit-search-results-button,
    &::-webkit-search-results-decoration {
      display: none;
    }

    &::placeholder {
      color: $color-grey-dark;
      font-size: 1rem;
    }
  }
}
</style>
